export function generateSrcDoc(htmlContent, darkMode) {
    if (darkMode == 'light'){
      return htmlContent/* .replace(/<head>\s*<style>/, `<head>
          <style>
              .darkImg{
                display: none !important;
              }
              .lightImg{
                display: block !important;
              }
          ` ) */
      }else{
    // Insert the dark mode styles into the <head> of the HTML
    return htmlContent.replace(
      /<head>\s*<style>/,
    /*   `<head>
      <meta name="color-scheme" content="dark">
        <style>
        @media (prefers-color-scheme: dark) {
            .backdrop{
               filter: invert(1) hue-rotate(180deg) !important;
            }
            .backdrop * img {
               filter: invert(1) hue-rotate(180deg) !important;
          }
        } 
        ` */ 
        //For testing the dark mode, removed the media query
        `<head>
        <style>
            .backdrop{
               filter: invert(1) hue-rotate(180deg) !important;
            }
            .backdrop * img {
               filter: invert(1) hue-rotate(180deg) !important;
            }`
            /* .darkImg{
              display: block !important;
            }
            .lightImg{
              display: none !important; */
    ); }
  }
  